import React, { Component } from 'react'
import Menu from '../Menu'
import Link from '../Link'
import AudioGallery from './AudioGallery'
import styles from './TourWork.css'

export default class TourWork extends Component {
  constructor (props) {
    super(props)
    this.state = {
      fixCaptions: false,
      currentAudio: this.props.tourWork.audio[0],
    }
  }

  componentDidMount () {
    this.scrollElement.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    this.scrollElement.removeEventListener('scroll', this.handleScroll)
    this.tickingScroll = false
    this.tickingAudioChange = false
  }

  handleScroll = () => {
    if (!this.tickingScroll) {
      this.tickingScroll = true
      window.requestAnimationFrame(this.updateScroll)
    }
  }

  updateScroll = () => {
    if (this.scrollElement.scrollTop > window.innerHeight * 0.5) {
      if (!this.state.fixCaptions) {
        this.setState({fixCaptions: true})
      }
    }
    else if (this.state.fixCaptions) {
      this.setState({fixCaptions: false})
    }
    this.tickingScroll = false
  }

  bindCaptionElement = (c) => {
    this.captionElement = c
  }

  bindScrollElement = (c) => {
    this.scrollElement = c
  }

  handleAudioChange = (audio) => {
    if (!this.tickingAudioChange) {
      this.tickingAudioChange = true
      window.requestAnimationFrame(this.doAudioChange(audio))
    }
  }

  doAudioChange = (audio) => () => {
    if (this.tickingAudioChange) {
      this.setState({ currentAudio: audio })
      this.tickingAudioChange = false
    }
  }

  render () {
    return (
      <div className={styles.cont}>
        <Menu logo={this.props.logo} menu={this.props.menu} linkBack/>
        <div className={styles.main} ref={this.bindScrollElement}>
          <HeroSwapper
            audio={this.props.tourWork.audio}
            currentAudio={this.state.currentAudio}
            roomNumber={this.props.tourWork.room}
            defaultTitle={this.props.tourWork.primaryTitle}
            defaultYear={this.props.tourWork.year}
            defaultImage={this.props.tourWork.image}
            defaultImagePosition={this.props.tourWork.imagePosition}
          />
          <div className={styles.body}>
            <AudioGallery audio={this.props.tourWork.audio} bindCaptionElement={this.bindCaptionElement} fixCaptions={this.state.fixCaptions} onAudioChange={this.handleAudioChange}/>
            <div className={styles.content} dangerouslySetInnerHTML={{__html: this.props.tourWork.description}}/>
            <Link to={'/tour/map'} className={styles.mapButton}>
              GO TO MAP
            </Link>
          </div>

        </div>
      </div>
    )
  }
}



class Hero extends Component {
  render () {
    return (
      <div className={styles.hero} style={{
        backgroundImage: 'url('+this.props.image+')',
        backgroundPosition: this.props.backgroundPosition || '',
        opacity: this.props.isVisible ? 1 : 0,
      }}>
        <div className={styles.heroTitle}>
          {this.props.roomNumber && (
            <div className={styles.heroRoomNumber}>
              {this.props.roomNumber}
            </div>
          )}
          {this.props.title}
        </div>
        <div className={styles.heroYear}>
          — {this.props.year}
        </div>
      </div>
    )
  }
}


class HeroSwapper extends Component {
  constructor (props) {
    super(props)
    this.state = {height: 0}
  }
  componentDidMount () {
    window.addEventListener('resize', this.tryUpdate)
    this.tryUpdate()
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.tryUpdate)
  }
  tryUpdate = () => {
    if (!this.ticking) {
      this.ticking = true
      this.update()
    }
  }
  update = () => {
    if (this.ticking) {
      this.setState({height: window.innerHeight * 0.7 - 81})
      this.ticking = false
    }
  }

  render () {
    return (
      <div
        className={styles.heroSwapper}
        style={{
          height: this.state.height,
        }}
      >
        {!this.props.audio.length && (
          <Hero
            roomNumber={this.props.roomNumber}
            title={this.props.defaultTitle}
            year={this.props.defaultYear}
            image={this.props.defaultImage}
            backgroundPosition={this.props.defaultImagePosition}
            isVisible={true}
          />
        )}
        {this.props.audio.map((audio, index) => (
          <Hero
            key={index}
            roomNumber={this.props.roomNumber}
            title={audio.primaryTitle || this.props.defaultTitle}
            year={audio.year || this.props.defaultYear}
            image={audio.image || this.props.defaultImage}
            backgroundPosition={audio.imagePosition || this.props.defaultImagePosition}
            isVisible={this.props.currentAudio == audio}
          />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/TourWork/index.js